import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';

/**
 * Encaixa os anexos que já são PDF dentro do relatório e numera o documento.
 *
 * O pdfmake não importa PDF: ele gera o relatório com uma FOLHA DE ROSTO por
 * anexo, sempre no fim do documento e na mesma ordem da lista. Aqui as páginas
 * originais de cada anexo entram logo depois da folha correspondente.
 *
 * A numeração só acontece aqui, no documento já montado: se o pdfmake numerasse,
 * o "de N" nasceria errado — as páginas dos anexos ainda não existiam.
 */

const CINZA = rgb(0.42, 0.49, 0.53);
const TAMANHO = 7;
const MARGEM = 40;
const BASE = 30; // mesma linha do rodapé desenhado pelo pdfmake

const bytesDoDataURL = dataURL => {
  const base64 = String(dataURL).split(',')[1] || '';
  return Buffer.from(base64, 'base64');
};

export default async function mesclaAnexosENumera(bytesRelatorio, anexosPdf, opcoes = {}) {
  const { abordagemId } = opcoes;
  const final = await PDFDocument.load(bytesRelatorio);
  const fonte = await final.embedFont(StandardFonts.Helvetica);
  const anexos = anexosPdf || [];
  const totalRelatorio = final.getPageCount();

  // as K últimas páginas do relatório são as folhas de rosto, em ordem;
  // inserindo de trás para frente, os índices anteriores não se deslocam.
  for (let k = anexos.length - 1; k >= 0; k -= 1) {
    const anexo = anexos[k];
    const posicaoDaFolha = totalRelatorio - anexos.length + k;

    let origem;
    try {
      // eslint-disable-next-line no-await-in-loop
      origem = await PDFDocument.load(bytesDoDataURL(anexo.dataURL));
    } catch (erro) {
      // anexo corrompido ou protegido por senha não pode derrubar a emissão:
      // a folha de rosto continua no documento e o original segue no sistema.
      // eslint-disable-next-line no-continue
      continue;
    }

    // eslint-disable-next-line no-await-in-loop
    const copiadas = await final.copyPages(origem, origem.getPageIndices());
    copiadas.forEach((pagina, i) => {
      // a folha do anexo, se for impressa e circular solta, precisa dizer de onde veio
      pagina.drawText(
        `Abordagem nº ${abordagemId} · SIG / Operação Foco · Anexo ${anexo.nome} ` +
          `· folha ${i + 1} de ${copiadas.length}`,
        { x: MARGEM, y: BASE, size: TAMANHO, font: fonte, color: CINZA }
      );
      final.insertPage(posicaoDaFolha + 1 + i, pagina);
    });
  }

  const paginas = final.getPages();
  paginas.forEach((pagina, i) => {
    const texto = `Página ${i + 1} de ${paginas.length}`;
    const largura = fonte.widthOfTextAtSize(texto, TAMANHO);
    pagina.drawText(texto, {
      x: pagina.getSize().width - MARGEM - largura,
      y: BASE,
      size: TAMANHO,
      font: fonte,
      color: CINZA,
    });
  });

  return final.save();
}
